import React from 'react';

const PrivacyAndPolicy = () => {
  return (
    <div className="privacy-policy-container bg-gray-100 text-gray-800 p-8">
      <h1 className="text-3xl font-bold mb-4">Samast Bharat Privacy and Policy</h1>
      <p className="mb-4">
        Welcome to SB-Finance. This Privacy Policy explains how we collect, use, and protect your personal information 
        when you use our loan, insurance, and credit card services. By using our services, you agree to the terms outlined below.
      </p>

      <h2 className="text-2xl font-semibold mb-2">1. Information We Collect</h2>
      <ul className="list-disc ml-6 mb-4">
        <li>Personal Identification Information: Name, address, email, phone number, date of birth, and government-issued ID details.</li>
        <li>Financial Information: Bank account details, credit history, income details, and transaction records.</li>
        <li>Loan and Insurance Details: Information related to loan applications, policies, claims, and credit card usage.</li>
        <li>Technical Information: IP address, browser type, device information, and browsing behavior on our website.</li>
      </ul>

      <h2 className="text-2xl font-semibold mb-2">2. How We Use Your Information</h2>
      <ul className="list-disc ml-6 mb-4">
        <li>To process and manage loan, insurance, and credit card applications.</li>
        <li>To verify your identity and assess your eligibility for financial products.</li>
        <li>To communicate updates, offers, and service-related notifications.</li>
        <li>To comply with legal and regulatory requirements.</li>
        <li>To improve our services and website experience through analytics.</li>
      </ul>

      <h2 className="text-2xl font-semibold mb-2">3. Information Sharing</h2>
      <p className="mb-4">
        SB-Finance may share your information with trusted third parties, including:
      </p>
      <ul className="list-disc ml-6 mb-4">
        <li>Government and regulatory authorities to comply with legal obligations.</li>
        <li>Credit bureaus and financial institutions for credit assessment and reporting.</li>
        <li>Third-party service providers for payment processing, data storage, and IT support.</li>
        <li>Insurance partners to process claims and manage policies.</li>
      </ul>

      <h2 className="text-2xl font-semibold mb-2">4. Data Security</h2>
      <p className="mb-4">
        We implement strict security measures to protect your personal information from unauthorized access, alteration, 
        disclosure, or destruction. Our security protocols include encryption, firewalls, and regular security audits.
      </p>

      <h2 className="text-2xl font-semibold mb-2">5. Your Rights</h2>
      <ul className="list-disc ml-6 mb-4">
        <li>Access: You can request a copy of your personal data held by us.</li>
        <li>Correction: You can request corrections to inaccurate or incomplete information.</li>
        <li>Deletion: You can request the deletion of your personal information, subject to legal obligations.</li>
        <li>Consent Withdrawal: You can withdraw your consent for marketing communications at any time.</li>
      </ul>

      <h2 className="text-2xl font-semibold mb-2">6. Cookies and Tracking</h2>
      <p className="mb-4">
        Our website uses cookies to enhance your browsing experience. You can manage cookie preferences through your browser settings.
      </p>

      <h2 className="text-2xl font-semibold mb-2">7. Policy Updates</h2>
      <p className="mb-4">
        SB-Finance reserves the right to update this Privacy Policy. Any changes will be communicated through our website or other appropriate channels.
      </p>

      <h2 className="text-2xl font-semibold mb-2">8. Contact Us</h2>
      <p className="mb-4">
        If you have any questions or concerns regarding our Privacy Policy, please contact us at:
      </p>
      <address className="ml-4">
        SB-Finance Advisor<br />
        Email: loanadvisor.roshan@gmail.com<br />
        Phone: +91 9103521459
      </address>
    </div>
  );
};

export default PrivacyAndPolicy;
